/**
 * Get user from store.
 */

import UserService from '../services/user.service';
import { setUser } from '../store/actions/user.actions';
import { useAppSelector } from '../store/hooks';
import { UserType } from '../types/user.types';

const useUser = (): { user: UserType; refreshUser: () => Promise<UserType> } => {
  const user = useAppSelector(({ userData }) => userData?.user);

  const refreshUser = async () => {
    const userService = new UserService();
    const userData = await userService.getCurrentUser();
    const updatedUserData = { ...user, ...userData };

    setUser(updatedUserData);

    return updatedUserData;
  };

  return { user, refreshUser };
};

export default useUser;
